import { Alert } from 'src/common/AlertManager';
import { atom } from 'jotai';

export const alertsAtom = atom<Alert[]>([]);
export const alertsPushedStateAtom = atom<boolean>(false);
